import { URLS } from '../../../constants';
import apiClient from '../../client';

const saveCriteriaTemplateAPI = {
    saveCriteriaTemplate: ({
        templateId,
        type,
        isSystemGenerated,
        name,
        description,
        createdBy,
        modifiedBy,
    }: {
        templateId: any;
        type: any;
        isSystemGenerated: any;
        name: any;
        description: any;
        createdBy: any;
        modifiedBy: any;
    }) =>
        apiClient.post(URLS.saveCriteriaTemplate, {
            data: {
                templateId,
                type,
                isSystemGenerated,
                name,
                description,
                createdBy,
                modifiedBy,
            },
        }),
    clearAllvalue: ({
        templateId,
        dataType,
    }: {
        templateId: any;
        dataType: any;
    }) => {
        try {
            const response = apiClient.post(URLS.clearValueInMasterCriteria, {
                data: {
                    templateId,
                    dataType,
                },
            });
            return response; // Or handle response as needed
        } catch (error) {
            console.error('Error clearing template values:', error);
            throw error; // Or handle the error as needed
        }
    },
};
export default saveCriteriaTemplateAPI;
